<template>
  <div class="public_FootBox">
		<div class="nav">
			<ul v-for="(item, index) in list" :key="index">
				<p><span class="sanjiao"></span>{{item.title}}</p>
				<div>
					 <span v-for="(items,indexs) in item.arr" :class="items.path !== '#' ? '_span' : ''" :key="indexs" @click.stop="items.path ? jump(items.path) : jumpGW()">{{items.text}}</span>
				</div>
			</ul>
			
		</div>
		<div class="Copyright">
			<div class="_copy">
				<p class="_p1">步峰代理仅提供IP代理服务，用户使用步峰代理从事的任何行为均不代表步峰代理的意志和观点，与步峰代理的立场无关。严禁用户使用步峰代理从事任何违法犯罪行为！</p>
				<p>山东步峰网络科技有限公司是经验丰富的企业级大数据基座服务商，提供互联网环境定制解决方案。</p>
				<p>我们的公司使命是：为客户创造更大的价值。</p>
				<div class="_p4">
					<p>增值电信业务经营许可证：B1.B2-20261249</p>
					
					<p>ICP备案号：<span @click.stop="openJG()" title="点击去核验">鲁ICP备2025205507号</span></p>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  name: 'Foot',
  props: {

  },
  data(){
    return{
			list:[
				{
					title:'站点地图',
					arr:[
						{text:'站点首页',path:'/'},
						{text:'帮助中心',path:'/newhelp'},
						// {text:'常见问题',path:'/newhelp'},
						{text:'获取API',path:'/accessApi'},
						// {text:'特殊定制',path:'/channel'},
						// {text:'Windows下载',path:''},
						// {text:'Android下载',path:''},
						// {text:'iOS下载',path:''},
					]
				},
				// {
				// 	title:'关于我们',
				// 	arr:[
				// 		{text:'公司介绍'}
				// 	]
				// },
				// {
				// 	title:'服务时间',
				// 	arr:[
				// 		{text:'周一到周五 08:30-18:00',path:'#'}
				// 	]
				// },
				{
					title:'联系方式',
					arr:[
						// {text:'QQ：2518035550',path:'#'},
						{text:'电话：13356645550',path:'#'},
						{text:'投诉电话：18953168846',path:'#'},
						{text:'公司地址：山东省济南市高新区大数据产业基地',path:'#'},
					]
				}
			]
    }
  },
  mounted(){
		this.showPageData()
  },
  methods:{
		openGA(){
			window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37108102000288')
		},
		openJG(){
			window.open('https://beian.miit.gov.cn/')
		},
		jumpGW(){
			window.open('http://www.chiyunwangluo.com')
		},
		jump(_path){
			if(_path !== '#'){
				this.$router.push({ path: _path })
			}
		},
		showPageData() {
			const pageData = this.$store.state.pageData
			if (pageData && Object.keys(pageData).length > 0) {
				this.list[this.list.length - 1].arr = [
					{text:'电话：'+ pageData.phone, path:'#'},
					{text:'投诉电话：'+ pageData.complaints_phone, path:'#'},
					{text:'公司地址：山东省济南市高新区大数据产业基地', path:'#'},
				]
			} else {
				this.getPageData()
			}
		},
		getPageData() {
      request({
				method: 'get', 
				url: Apis.getAboutUs,
				params:{},
				_type:1
			}).then(res => {
        this.list[this.list.length - 1].arr = [
					{text:'电话：'+ pageData.phone, path:'#'},
					{text:'投诉电话：'+ pageData.complaints_phone, path:'#'},
					{text:'公司地址：山东省济南市高新区大数据产业基地', path:'#'},
				]
        this.$store.commit("savePageData", res.data);
      })
    }
  }
}
</script>

<style scoped lang="scss">
.public_FootBox{
	width: 100%;
	// margin-top: 20px;
	width: 100%;
	background: #F3F3F3;

	.nav{
		width: 1200px;
		height: 280px;
		margin: 0 auto;
		display: flex;
		// justify-content: space-between;
		ul{
			// width: 33%;
			flex: 1;
			padding: 10px;
			margin-top: 38px;
			p{
				font-weight: bold;
				font-size: 18px;
				color: #1E1D1D;
				text-align: left;
				span{
					display: inline-block;
					width: 0;
					height: 0;
					border-left: 10px solid #51B3FF;
					border-top: 8px solid transparent;
					border-bottom: 8px solid transparent;
					margin-left: 10px;
					line-height: 50px;
					// margin-top: 10px;
					margin-right:5px;
				}
			}
			div{
				padding: 0 1px;
				margin-top: 10px;
				display: flex;
				flex-wrap: wrap;
				span{
					display: inline-block;
					padding:0 18px;
					font-size: 18px;
					line-height: 40px;
					color: #878787;
				
				}
				._span:hover{
					color: #51B3FF;
					cursor:pointer;
				}
			}
		}
		ul:nth-child(1){
			width: 500px;
		}
		ul:nth-child(2){
			width: 420px;
		}
		ul:nth-child(3){
			width: 60%;
			div{
				span{
					width: 100%;
					text-align: left;
				}
			}
		}
	}
	.Copyright{
    width: 100%;
    height: 210px;
    background: #fff;
    ._copy{
			width: 1200px;
			height: 100%;
			margin: 0 auto;
			// padding-top: 5px;
			padding-top: 20px;
			text-align: center;
			._p1{
				color: #2d2d2d;
				// color: #7e7e7e;
				font-weight: 900;
			}
			p{
				line-height: 34px;
				font-size: 14px;
				color: #7e7e7e;
				// color: #6B6B6B;
			}
    }
	}
	._p4{
		display: flex;
		justify-content: center;
		p{
			font-size: 16px !important;
			&:nth-child(2){
				margin-left: 10px;
			}
			span{
				cursor: pointer;
				&:hover{
					color: #208EFF;
					text-decoration: underline;
				}
			}
		}
	}
}

 @media screen and (max-width: 1200px) {
	 .public_FootBox{
		 min-width:1000px;
	 	// width:expression(document.body.clientWidth < 1000px? "1000px": "auto" );
	 }
	 
 }
</style>



